module.exports = __webpack_public_path__ + "img/no_data_found.5edd86b9.jpg";